{
  "version": 1,
  "asset_id": "e0c06200-2eac-47c8-b712-d524b28f20e2",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e0c06200-2eac-47c8-b712-d524b28f20e2/bypass-revision-completed-pouch-en-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e0c06200-2eac-47c8-b712-d524b28f20e2/bypass-revision-completed-pouch-en-1200.webp",
  "original_filename": "bypass-revision-completed-pouch-en-1200.webp",
  "size": 59698,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:12:57Z"
}
